import Page from "../Common/Page";
import React from "react";
import {
  Form,
  Radio,
  Button,
  Row,
  Col,
  Table,
  Space,
  Upload,
  Tooltip,
  message,
} from "antd";
import { QuestionCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { Messages } from "../Common/ValidateMessages";
import { httpForm, httpForBlob } from "../Common/http";
import { AuthContext } from "../Auth/Auth";

type FormData = {
  type: string;
};

interface ReminderDataFromServer {
  status: number;
  examinationData: [];
  errList: [];
  numberOfCSVData: number;
  numberOfSuccesses: number;
  numberOfFailures: number;
}

export class ApplicantPage extends React.Component {
  state = {
    type: "1",
    fileList: [],
    uploading: false,
    errData: [],
    importInfomation: "",
  };
  private _page: React.RefObject<Page>;
  static contextType = AuthContext;
  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
  }

  submitForm = async (formData: FormData) => {
    this._page.current?.setState({ isPageLoading: true });

    try {
      if (formData.type === "1") {
        const result = await httpForBlob({
          path: "/ApplicantImport/template",
          method: "get",
          accessToken: this.context.accessToken,
        });
        if (result.size > 0) {
          const csvfile = window.URL.createObjectURL(result);
          await fetch(csvfile);
          const link = document.createElement("a");
          link.href = csvfile;
          link.download = "ApplicantTemplate.csv";
          document.body.appendChild(link);
          link.click();
          link.remove();
          this._page.current?.setState({ isPageLoading: false });
        } else {
          // 試験データが1件もない場合のメッセージ
          message.error(Messages["ERR-019"]);
          this._page.current?.setState({ isPageLoading: false });
        }
      } else if (formData.type === "2") {
        const { fileList } = this.state;

        this.setState({
          errData: [],
        });

        if (fileList.length === 0) {
          // CSVが指定されていないとき
          message.error(Messages["ERR-021"]);
          this._page.current?.setState({ isPageLoading: false });
        } else {
          const PostData = new FormData();
          PostData.append("FormFiles", fileList[0]);

          const result = await httpForm<ReminderDataFromServer>(
            {
              path: "/ApplicantImport",
              method: "post",
              accessToken: this.context.accessToken,
            },
            PostData
          );
          if (result.ok && result.body) {
            // CSVアップロード処理完了メッセージ
            // 全件XX件、成功XX件、失敗XX件 result.body.numberOfCSVData result.body.numberOfSuccesses result.body.numberOfFailures
            const Msg = ` :全件${result.body.numberOfCSVData}件、成功${result.body.numberOfSuccesses}件、失敗${result.body.numberOfFailures}件`;

            this.setState({
              importInfomation: Msg,
              fileList: [],
              errData: result.body.errList,
            });
            message.info(Messages["MSG-002"]);
            this._page.current?.setState({ isPageLoading: false });
          } else {
            if (result.body?.status === 400) {
              // ShiftJISではない
              message.error(Messages["ERR-022"]);
              this._page.current?.setState({ isPageLoading: false });
            } else {
              // その他エラー
              message.error(Messages["ERR-020"]);
              this._page.current?.setState({ isPageLoading: false });
            }
          }
        }
      } else if (formData.type === "3") {
        const result = await httpForBlob({
          path: "/ApplicantImport/export",
          method: "get",
          accessToken: this.context.accessToken,
        });
        if (result.size > 0) {
          const csvfile = window.URL.createObjectURL(result);
          await fetch(csvfile);
          const link = document.createElement("a");
          link.href = csvfile;
          link.download = "ExaminationApplicant.csv";
          document.body.appendChild(link);
          link.click();
          link.remove();
          this._page.current?.setState({ isPageLoading: false });
        } else {
          // 試験データが1件もない場合のメッセージ
          message.error(Messages["ERR-019"]);
          this._page.current?.setState({ isPageLoading: false });
        }
      }
    } catch (error) {
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onChange = (e: any) => {
    this.setState({
      type: e.target.value,
    });
  };

  onFormValueChange = () => {
    this.setState({
      importInfomation: "",
      errData: [],
    });
  };

  fixedColumns = [
    {
      title: "行番号",
      dataIndex: "lineNo",
      fixed: true,
      width: 100,
    },
    {
      title: "カラム名",
      dataIndex: "column",
      fixed: true,
      width: 100,
    },
    {
      title: "エラー内容",
      dataIndex: "errMessage",
    },
  ];

  render() {
    const { type, errData } = this.state;
    const fixedData: any[] = [];

    errData.forEach((value) => {
      fixedData.push({
        key: value["lineNo"],
        lineNo: value["lineNo"],
        column: value["column"],
        errMessage: value["errMessage"],
      });
    });

    const { fileList } = this.state;
    const uploadProps = {
      onRemove: (file: any) => {
        this.setState({
          fileList: [],
        });
      },
      beforeUpload: (file: any) => {
        const isCsv =
          file.type === "text/csv" || file.type === "application/vnd.ms-excel";
        if (!isCsv) {
          message.error(Messages["ERR-021"]);
          return false;
        }
        this.setState({
          fileList: [file],
        });
        return false;
      },
      fileList,
    };
    return (
      <Page title="志願者情報取込" ref={this._page}>
        <div className="data_content" style={{ marginTop: "10px" }}>
          <Form
            name="applicant"
            layout="vertical"
            onFinish={this.submitForm}
            onValuesChange={this.onFormValueChange}
            autoComplete="off"
            className="login-form"
            encType="multipart/form-data"
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="type"
                  label="処理種別"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Radio.Group onChange={this.onChange} value={type}>
                    <Space direction="vertical">
                      <Radio value="1">
                        <Tooltip
                          placement="right"
                          title="新規データをインポートする場合は、テンプレートファイルをダウンロード後、インポートを行ってください"
                        >
                          CSVテンプレートダウンロード
                          <span className="tooltip-icon">
                            <QuestionCircleOutlined />
                          </span>
                        </Tooltip>
                      </Radio>
                      <br />
                      <Radio value="2">
                        <Tooltip
                          placement="right"
                          title="システムへのデータ登録/修正/削除を行います"
                        >
                          インポート
                          <span className="tooltip-icon">
                            <QuestionCircleOutlined />
                          </span>
                        </Tooltip>
                        <br />
                        <Form.Item
                          name="FormFiles"
                          style={{ marginTop: "5px" }}
                        >
                          <Upload {...uploadProps} name="" maxCount={1}>
                            <Button icon={<UploadOutlined />}>
                              CSVファイル選択
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Radio>
                      <Radio value="3">
                        <Tooltip
                          placement="right"
                          title={
                            <p>
                              登録されているデータをダウンロードします。
                              <br />
                              ※登録済データを更新/削除する場合は、エクスポート後、CSVの先頭カラムの値を
                              [2:更新] や [3:削除]
                              それぞれの値に変更の上、データ修正を行った後、上記インポートを行います。
                            </p>
                          }
                        >
                          エクスポート
                          <span className="tooltip-icon">
                            <QuestionCircleOutlined />
                          </span>
                        </Tooltip>
                      </Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
                <Form.Item>
                  <div style={{ display: "flex" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginLeft: "220px" }}
                    >
                      処理実行
                    </Button>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <h3>処理結果{this.state.importInfomation}</h3>
          <Table
            columns={this.fixedColumns}
            dataSource={fixedData}
            pagination={false}
            scroll={{ y: "calc(100vh - 420px)" }}
            bordered
          />

          <br />
          <br />
        </div>
      </Page>
    );
  }
}
export default ApplicantPage;
